var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectBgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#0b0e28"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(894 567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -147L127.3 -73.5L127.3 73.5L0 147L-127.3 73.5L-127.3 -73.5Z",
    fill: "#558fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(492 215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -129L111.7 -64.5L111.7 64.5L0 129L-111.7 64.5L-111.7 -64.5Z",
    fill: "#558fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155 328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -56L48.5 -28L48.5 28L0 56L-48.5 28L-48.5 -28Z",
    fill: "#558fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(799 154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -76L65.8 -38L65.8 38L0 76L-65.8 38L-65.8 -38Z",
    fill: "#558fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(429 596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -125L108.3 -62.5L108.3 62.5L0 125L-108.3 62.5L-108.3 -62.5Z",
    fill: "#558fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(251 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -90L77.9 -45L77.9 45L0 90L-77.9 45L-77.9 -45Z",
    fill: "#558fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBgDark);
export default __webpack_public_path__ + "static/media/project_bg_dark.e5c3fc127de1eb7dac6ae4bd924626fa.svg";
export { ForwardRef as ReactComponent };